import React, {useState} from "react";
import axios from "axios";
import {NumericFormat} from "react-number-format";
import TextField from "@mui/material/TextField";
import {handleChangeValue} from "../../../utils/handleChangeValue";
import Select from "react-select";
import FormControlLabel from "@mui/material/FormControlLabel";
import {Switch} from "@mui/material";
import {Button} from "react-bootstrap";

export default function OrderManagementInputs({baseUrl, setShowInputs, setLoadItens, listPapel}) {

    const [isLoading, setIsLoading] = useState(false);

    const [papelLeilaoId, setPapelLeilaoId] = useState(0);
    const [porcentagem, setPorcentagem] = useState(3);
    const [valorPago, setValorPago] = useState(false);


    const postItem = (e) => {

        e.preventDefault()

        if (papelLeilaoId === 0 || !papelLeilaoId
            || porcentagem <= 0 || porcentagem >= 100)
            return

        const data = {
            papelLeilaoId,
            porcentagem,
            valorPago
        }

        setIsLoading(true)
        axios.post(baseUrl, data)
            .then(() => {
                setLoadItens(true)
                setShowInputs(false)
            })
            .catch(() => {
            }).finally(() => setIsLoading(false))
    }

    return <form action={postItem} style={{textAlign: 'center'}} className="form-inputs">
        <h4>Adicionar Gerenciamento</h4>

        <Select
            className="basic-single"
            classNamePrefix="select"
            id="form_select"
            isDisabled={false}
            isLoading={false}
            isClearable={true}
            isRtl={false}
            isSearchable={true}
            options={listPapel}
            defaultValue={listPapel.find(item => item.value === papelLeilaoId)}
            onChange={(e) => setPapelLeilaoId(e?.value)}
            placeholder='Comprador'
            required
        />

        <NumericFormat
            className='mt-3'
            customInput={TextField}
            thousandSeparator="."
            decimalSeparator=","
            suffix=' %'
            decimalScale={2}
            label="Taxa de Administração (%)"
            max='999999'
            inputProps={{
                min: 1,
                max: 10,
                maxLength: 5,
                step: ".01"
            }}
            InputLabelProps={{
                style: {
                    zIndex: 0,
                },
            }}
            value={porcentagem}
            onValueChange={(e) => handleChangeValue(e, setPorcentagem)}
            required
            fullWidth
        />


        <FormControlLabel control={
            <Switch onChange={() => setValorPago(prevState => !prevState)} />
        } label="Cobrar por valor pago (incluindo júros e multa)" />

        <Button
            onClick={postItem}
            disabled={isLoading}
            className={isLoading ? "btn btn-secondary" : ""}
        >
            {isLoading ? (<>
                          <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                          ></span>
                &nbsp;Aguarde...
            </>) : (<>Adicionar</>)}
        </Button>
    </form>

}
